exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._media__media__1-Jrj {\n  display: flex; }\n\n._media__media-body__3QMXa {\n  flex: 1; }\n\n._media__media-middle__2Yqxd {\n  align-self: center; }\n\n._media__media-bottom__H3yVl {\n  align-self: flex-end; }\n\n._media__media-object__3HiGA {\n  display: block; }\n  ._media__media-object__3HiGA._media__img-thumbnail__1NWMI {\n    max-width: none; }\n\n._media__media-right__1QmV_ {\n  padding-left: 10px; }\n\n._media__media-left__3ZY_B {\n  padding-right: 10px; }\n\n._media__media-heading__gCAVW {\n  margin-top: 0;\n  margin-bottom: 5px; }\n\n._media__media-list__ipVc- {\n  padding-left: 0;\n  list-style: none; }\n", ""]);

// exports
exports.locals = {
	"media": "_media__media__1-Jrj",
	"media-body": "_media__media-body__3QMXa",
	"media-middle": "_media__media-middle__2Yqxd",
	"media-bottom": "_media__media-bottom__H3yVl",
	"media-object": "_media__media-object__3HiGA",
	"img-thumbnail": "_media__img-thumbnail__1NWMI",
	"media-right": "_media__media-right__1QmV_",
	"media-left": "_media__media-left__3ZY_B",
	"media-heading": "_media__media-heading__gCAVW",
	"media-list": "_media__media-list__ipVc-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/_media.scss
// module id = 395
// module chunks = 0 1